var map = {
	"./amex.png": 959,
	"./diners.png": 960,
	"./discover.png": 961,
	"./jcb.png": 962,
	"./maestro.png": 1190,
	"./mastercard.png": 963,
	"./stripe.png": 964,
	"./union.png": 965,
	"./unknown.png": 626,
	"./visa.png": 966
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1189;